var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        class: [
          "alert ui-alert",
          "alert-" + _vm.computedType,
          {
            "ui-alert--small": _vm.size === "small",
            "ui-alert--full-width": _vm.fullWidth,
            "alert-dismissible": _vm.dismissible,
            fade: _vm.dismissible,
            show: _vm.dismissible && _vm.visible,
            "Alert-top": _vm.isLegacyAlertTop,
            "alert-promo": _vm.isLegacyAlertPromo,
            "center-top": _vm.isPositionTopCenter,
          },
        ],
        attrs: { role: "alert" },
      },
      [
        _c(
          "div",
          {
            class: [
              "alert__content",
              {
                container: _vm.fullWidth,
                "alert__content--small": _vm.size === "small",
              },
            ],
          },
          [
            _vm.$slots.badge ? _c("div", [_vm._t("badge")], 2) : _vm._e(),
            _vm._v(" "),
            _vm.$slots.icon || !_vm.noIcon
              ? _c(
                  "div",
                  { staticClass: "alert__icon" },
                  [
                    _vm._t("icon", function () {
                      return [
                        _vm.iconComponent
                          ? _c(_vm.iconComponent, { tag: "component" })
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "alert__title-wrapper" }, [
              _vm.$slots.title || _vm.title
                ? _c(
                    "div",
                    { staticClass: "alert__title" },
                    [
                      _vm._t("title", function () {
                        return [
                          _vm.title
                            ? _c("div", {
                                domProps: { innerHTML: _vm._s(_vm.title) },
                              })
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$slots.description || _vm.description
                ? _c(
                    "div",
                    {
                      class: [
                        "alert__description",
                        { small: _vm.smallDescription },
                      ],
                    },
                    [
                      _vm._t("description", function () {
                        return [
                          _vm.description
                            ? _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.description),
                                },
                              })
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.dismissible
          ? _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "aria-label": "Close" },
                on: { click: _vm.closeAlert },
              },
              [_c("svg-alert-close")],
              1
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }